import { Box, type SxProps, type Theme } from '@mui/material'
import { useImageLoader } from '~sharedLib'

export const SafeImage = ({ src, alt, sx }: {
	src: string | undefined | null
	alt?: string
	sx?: SxProps<Theme>
}) => {
	const isLoaded = useImageLoader(src)

	if (!isLoaded || !src) return null

	return (
		<Box
			sx={sx}
		>
			<img src={src} alt={alt} style={{ width: '100%', objectFit: 'cover', height: '100%' }} />
		</Box>
	)
}
